import React from 'react';

import { OrderPaymentProps } from '../../types';

export const HostedPagePayment: React.FC<OrderPaymentProps> = () => null;
